module.exports = {"tel":"Festnetz","mobile":"Mobil","fax":"Fax","email":"E-Mail","web":"Webseite","other":"Andere"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/contactDetails/de.json
// module id = 249
// module chunks = 1